import { lastValueFrom } from 'rxjs';

import {
  addProductToWishList,
  getWishList, getWishListSuccess, removeProductFromWishList, removeProductFromWishListSuccess, setProductsWishListSuccess
} from '../slices/wishList.slice';

import { addApiErrorToast } from '../slices/toast.slice';
import { AppListenerEntry } from '@/redux';
import { PAGES } from '@/constants/pages';

export const epicSyncWishList: AppListenerEntry = {
  matcher: (action) => action.type === 'HYDRATE',
  effect: async (_action, { getState, dispatch }) => {
    if (getState().wishList?.pendingProductIdForWishList) {
      dispatch(addProductToWishList({ partnumber: getState().wishList?.pendingProductIdForWishList, hydrate: true }));
    }
  }
};

export const epicGetWishList: AppListenerEntry = {
  actionCreator: getWishList,
  effect: async (_action: ReturnType<typeof getWishList>, { getState, dispatch, extra: { userService } }) => {
    const storeId = getState().root?.storeConf?.storeId;

    try {
      const user = await lastValueFrom(userService.get(storeId));
      if (user?.wishList) {
        dispatch(getWishListSuccess({ products: user.wishList }));
      }
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicAddProductToWishList: AppListenerEntry = {
  actionCreator: addProductToWishList,
  effect: async ({ payload }: ReturnType<typeof addProductToWishList>, { dispatch, extra: { wishListService } }) => {
    try {
      await lastValueFrom(wishListService.addToWishList(payload.partnumber));
      if (payload.hydrate) {
        dispatch(getWishList());
      }
    } catch (error) {
      dispatch(removeProductFromWishList({ partnumber: payload.partnumber }));
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicRemoveProductFromWishList: AppListenerEntry = {
  actionCreator: removeProductFromWishList,
  effect: async ({ payload }: ReturnType<typeof removeProductFromWishList>, { dispatch, extra: { wishListService } }) => {
    try {
      const partnumber = await lastValueFrom(wishListService.removeFromWishList(payload.partnumber)) as any;
      dispatch(removeProductFromWishListSuccess({ partnumber }));
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicRemoveProductFromWishListSuccess: AppListenerEntry = {
  actionCreator: removeProductFromWishListSuccess,
  effect: async (
    _action: ReturnType<typeof removeProductFromWishListSuccess>,
    { getState, dispatch, extra: { wishListService } }
  ) => {
    if (window.location.href.endsWith(PAGES.WISHLIST)) {
      const storeId = getState().root?.storeConf?.storeId;
      const storeIdForPrice = getState().gui?.storeIdForPrice;
      const storeIdWishList = (storeIdForPrice && storeIdForPrice !== '12004') ?
        `${storeId}-${storeIdForPrice}` : storeId;

      try {
        const productsWishList = await wishListService.get(storeIdWishList);
        dispatch(setProductsWishListSuccess({ products: productsWishList }));
      } catch (error) {
        dispatch(addApiErrorToast({ error }));
      }
    }
  }
};
